<template>
  <div id="footer" class="container-fluid">
    <p class="title">河南丽景教育科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：河南省郑州市高新技术产业开发区科学大道89号</span>
    </p>
    <p class="email_wx">
      <a :href="'tel:' + '19542915941'">杨老师tel/微信：1954291594</a>
      <a :href="'tel:' + '19339833157'">王老师tel/微信：19339833157</a>
    </p>
    <p class="email_wx">
      <a href="http://81rc.81.cn/sy/zczd_210285/16260578.html" target="_blank"
        >军队人才网 /
      </a>
      <a href="https://gaokao.chsi.com.cn/" target="_blank">阳光高考网 /</a>
      <a
        href="https://gaokao.chsi.com.cn/zyk/zybk/zyjd/listPage"
        target="_blank"
        >专业解读汇总 /</a
      >
      <a
        href="https://gaokao.chsi.com.cn/gkxx/zt/gkggfahz.shtml"
        target="_blank"
        >各省高考改革汇总 /</a
      >
      <a
        href="https://gaokao.chsi.com.cn/gkxx/zc/ss/202201/20220105/2155365943.html"
        target="_blank"
        >各省本科专业选考科目 /</a
      >
      <a
        href="https://gaokao.chsi.com.cn/gkxx/zt/2024gkzx.shtml"
        target="_blank"
        >2024考生常见问题</a
      >
    </p>
    <p class="copy">
      <a
        href="https://mp.weixin.qq.com/s/T4moD1xld16cwjU_JXub9A"
        target="_blank"
        style="color: aliceblue;"
        >26军校</a
      >
      <a
        href="https://mp.weixin.qq.com/s/T4moD1xld16cwjU_JXub9A"
        target="_blank"
        style="color: aliceblue;"
        >25军校简章</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/s/wvCuBlbunimmNW3LtqlSzA"
        target="_blank"
        style="color: aliceblue;"
        >24军校简章</a
      >
      <a
        href="https://mp.weixin.qq.com/s/Ldre6WxwfZMqLFWctxgpSA"
        target="_blank"
        style="color: aliceblue;"
        >23军校简章</a
      >
      <a
        href="https://mp.weixin.qq.com/s/Wp_GTkmaL0dYePR-eQOi6g"
        target="_blank"
        style="color: aliceblue;"
        >26招生人数</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/s/gxytpK4eq83pBhsJRbCvLQ"
        target="_blank"
        style="color: aliceblue;"
        >25招生人数</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/s/E42T5GDXMPiQeqk_F5wShA"
        target="_blank"
        style="color: aliceblue;"
        >24招生人数</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/s/E42T5GDXMPiQeqk_F5wShA"
        target="_blank"
        style="color: aliceblue;"
        >24招生人数</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/s/dYWQQJIVq5FUfXfX4zwd5g"
        target="_blank"
        style="color: aliceblue;"
        >军校体检标准</a
      >
      /
      <a
        href="https://m.youzy.cn/news/detail?id=67e656963ab8ea35126961be&isShare=true"
        target="_blank"
        style="color: aliceblue;"
        >25年志愿填报时间</a
      >
      /
      <a
        href="https://mp.weixin.qq.com/mp/appmsgalbum?action=getalbum&__biz=MzkyNTUxNDA5MQ==&scene=1&album_id=4038952708555030543&count=3#wechat_redirect"
        target="_blank"
        style="color: aliceblue;"
        >25年各省政审安排</a
      >
    </p>
    <p class="copy">
      Copyright &copy; 2018 -
      {{ new Date().getFullYear() }}
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: aliceblue;"
        >豫ICP备2024057885号</a
      >
      <span>豫公网安备41019702003527号</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  padding: 10px;
  color: #fff;
  background: #4183db;
  overflow: hidden;
  text-align: center;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.email_wx a {
  color: #d3d3d3;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue